import { render, staticRenderFns } from "./sxgl.vue?vue&type=template&id=ca4e1994&scoped=true"
import script from "./sxgl.vue?vue&type=script&lang=js"
export * from "./sxgl.vue?vue&type=script&lang=js"
import style0 from "./sxgl.vue?vue&type=style&index=0&id=ca4e1994&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca4e1994",
  null
  
)

export default component.exports